import { IconProps } from "@assets";

const GlobeLanguage = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3602_57797)">
                <path
                    d="M12.0002 24C5.38298 24 0 18.617 0 11.9998C0 5.38298 5.38298 0 12.0002 0C18.617 0 23.9995 5.38298 23.9995 11.9998C23.9995 18.617 18.617 24 12.0002 24ZM12.0002 1.00781C5.93916 1.00781 1.00734 5.93881 1.00734 11.9998C1.00734 18.0608 5.93881 22.9918 12.0002 22.9918C18.0607 22.9918 22.9914 18.0613 22.9914 11.9998C22.9914 5.93881 18.0608 1.00781 12.0002 1.00781Z"
                    fill={props.color ?? "white"}
                />
                <path d="M23.3276 11.4961H0.671875V12.5039H23.3276V11.4961Z" fill={props.color ?? "white"} />
                <path
                    d="M12.2725 7.26218C6.58392 7.26218 2.33937 6.01043 2.0752 5.93044L2.36685 4.96531C2.46228 4.9942 12.033 7.81122 21.5899 4.96484L21.8766 5.93079C18.5247 6.92948 15.2054 7.26218 12.2725 7.26218Z"
                    fill={props.color ?? "white"}
                />
                <path
                    d="M2.38717 18.781L2.09961 17.815C11.9545 14.882 21.5001 17.6949 21.9018 17.815L21.6102 18.7805C21.5143 18.7513 11.9444 15.9355 2.38717 18.781Z"
                    fill={props.color ?? "white"}
                />
                <path
                    d="M8.11594 22.9391C3.14986 11.3126 7.43592 1.0049 7.47978 0.902344L8.40678 1.29738C8.3641 1.39619 4.25134 11.3259 9.04295 22.5431L8.11594 22.9391Z"
                    fill={props.color ?? "white"}
                />
                <path
                    d="M15.8069 22.9426L14.8799 22.5471C19.6711 11.3299 15.5583 1.4001 15.5156 1.30128L16.4426 0.90625C16.4857 1.00834 20.7722 11.316 15.8069 22.9426Z"
                    fill={props.color ?? "white"}
                />
                <path d="M12.5034 0.671875H11.4961V23.7449H12.5034V0.671875Z" fill={props.color ?? "white"} />
            </g>
            <defs>
                <clipPath id="clip0_3602_57797">
                    <rect width="24" height="24" fill={props.color ?? "white"} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default GlobeLanguage;
